import $ from "jquery";
import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setSQFTContextMenu} from "../../../../../../../actions/sqftMenuFunctions";
import SqftContextMenu from "../../shapes/overlays/sqftContextMenu";
import {injectIntl} from "react-intl";
import {CONTEXT_MENU_TYPE, ALLOWED_LABEL_NAV_ITEMS} from "../../../../../constants";
import {updateSQFTCalculations} from "../../../../../../../actions/sqftFunctions";
import {getCurrentLayout} from "../../../../../../appLayout";
import {initLabel, updateShape} from "./labelsHelper";
import {getFeatureGroupName} from "../../../../../../../misc/helpers";
import {
  getAvailableSteps, getFeatureGroupFromWizardGroup,
  showWizardInsteadOfQT
} from "../../../../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";

const SqftLabelsContextMenuCategorySwitching = (props) => {
  const {contextMenu, qtActiveCategoryName, selectionGroup, setSQFTContextMenu, fabricatorData, intl,
    updateCalculations, updateSQFTCalculations, activeRoomId, wizardList, wizardIsActive, wizardActiveItem,
    wizardSelectedValues} = props;
  const CONTEXT_ACTIVE_MENU_NAME = "labels";
  const [contextMenuButtons, setContextMenuButtons] =  useState([]);
  // const layout = getCurrentLayout();
  // console.log("getActiveFeatures", layout.getActiveFeatures())
  // console.log("getActiveFeaturesAsObject", layout.getActiveFeaturesAsObject(false, true, true))

  useEffect(() => {
    const layout = getCurrentLayout();
    let subParts = [];
    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      const wizardSteps = getAvailableSteps(wizardActiveItem, wizardSelectedValues, true);
      //console.log("wizardSteps", wizardSteps);
      wizardSteps.forEach((wizardStep) => {
        if (wizardStep.stepGroups.length === 1) {
          const wizardGroup = wizardStep.stepGroups[0];
          const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
          if (featureGroup && Object.keys(ALLOWED_LABEL_NAV_ITEMS).includes(featureGroup.partId)) {
            if (wizardGroup.separateSqftLabel && wizardGroup.title && (wizardGroup.title !== featureGroup.groupName)) {
              if (!subParts.some(subPart => subPart.wizardGroup && (subPart.wizardGroup.title === wizardGroup.title))) {
                subParts.push({part: featureGroup, labelName: wizardGroup.title, wizardGroup})
              }
            } else if (!subParts.some(subPart => subPart.part.partId === featureGroup.partId)) {
              subParts.push({part: featureGroup})
            }
          }
        }
      })
    } else {
      if (layout.qtCategories && qtActiveCategoryName) {
        const qtActiveCategory = layout.qtCategories.find(qtCategory => qtCategory.name === qtActiveCategoryName)
          || layout.qtCategories[0]; // cases when visualizerType is changed
        subParts = qtActiveCategory.subParts;
      } else {
        const activePart = layout.parts[selectionGroup]
        if (activePart) {
          subParts = activePart.subParts(false);
        }
      }
      subParts = subParts.filter((subpart) => {
        return Object.keys(ALLOWED_LABEL_NAV_ITEMS).includes(subpart.part.partId)
      })
    }
    setContextMenuButtons(subParts);
  }, [qtActiveCategoryName, selectionGroup, activeRoomId, wizardActiveItem, wizardSelectedValues, wizardIsActive,
    wizardList])

  const handleContextMenuClicked = (e, item) => {
    switch (item.partId) {
      case 'custom' : {
        let popupId = 'label';
        var confirmPopup = popupId ? $('.message-box-overlay-' + popupId) : $('.message-box-overlay');
        confirmPopup.fadeIn(300);
        break;
      }
      default : {
        updateShape(item.part?.partId, contextMenu.parent, item.wizardGroup);
        initLabel(item.labelName || getFeatureGroupName(item.part, intl, fabricatorData), item.part?.partId, contextMenu.parent);
        break;
      }
    }

    updateSQFTCalculations(updateCalculations + 1);
    setSQFTContextMenu({isOpened: false});
  };

  const className = contextMenu.isOpened && contextMenu.activeMenu === CONTEXT_ACTIVE_MENU_NAME ? "" : "hidden";

  return contextMenu.isOpened ? (
    <div className={"labels-contextmenu " + className}>
      <SqftContextMenu
        handleItemClick={handleContextMenuClicked}
        pos={contextMenu.pos}
        contextMenuType={CONTEXT_MENU_TYPE.list}
        contextMenuTitle={intl.formatMessage({id: "sqft.contextmenu.title"})}
        contextMenuSelection={null}
        contextMenuButtons={contextMenuButtons}/>
    </div>
  ) : null
};

const mapStateToProps = (store) => ({
  contextMenu: store.sqftMenuState.contextMenu,
  fabricatorData: store.fabricatorState,
  updateCalculations: store.sqftState.updateCalculations,
  qtActiveCategoryName: store.qtState.qtActiveCategory,
  selectionGroup: store.selectionState.selectionGroup,
  qtActiveCategory: store.qtState.qtActiveCategory,
  activeRoomId: store.sqftMenuState.activeRoomId,
  wizardList: store.wizardState.wizardList,
  wizardActiveItem: store.wizardState.wizardActiveItem,
  wizardSelectedValues: store.wizardState.wizardSelectedValues,
  wizardIsActive: store.wizardState.wizardIsActive,
});

const mapDispatchToProps = {
  setSQFTContextMenu,
  updateSQFTCalculations,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftLabelsContextMenuCategorySwitching)
)
